import Fancybox29x19 from "../MakeFancyBox/Fancybox29x19";
import Fancybox29x19Planshet from "../MakeFancyBox/Fancybox29x19Planshet";

export function ShowClaim29x19() {
  return (
    <>
      <h4 className="m-3 text-center text-danger">Розміри 29x19</h4>
      <div className="row">
        <div className="col-md-8">
          <h3>Вимоги до файлів</h3>

          <table class="table table-striped">
            <tbody>
              <tr>
                <th scope="row" className="text-success">
                  Формат файлу
                </th>
                <td>JPG (максимальна якість)</td>
              </tr>
              <tr>
                <th scope="row" className="text-success">
                  Колірна модель
                </th>
                <td>RGB, профіль sRGB IEC61966</td>
              </tr>
              <tr>
                <th scope="row" className="text-success">
                  Розширення
                </th>
                <td>300 dpi(точок на дюйм)</td>
              </tr>
              <tr>
                <th scope="row" className="text-success">
                  Файл обкладинки A (для 3-25 розворотів)
                </th>
                <td>614 х 223 мм (7252 x 2634 пікселів)</td>
              </tr>
              <tr>
                <th scope="row" className="text-success">
                  Файл обкладинки B (для 26-40 розворотів)
                </th>
                <td>627 х 223 мм (7406 x 2634 пікселів)</td>
              </tr>
              <tr>
                <th scope="row" className="text-success">
                  Файл розвороту
                </th>
                <td>566 х 193 мм (6685 x 2280 пікселів)</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="col-md-4">
          <Fancybox29x19 />
        </div>
      </div>
    </>
  );
}

export function ShowClaim29x19Photo() {
  return (
    <>
      <h4 className="m-3 text-center text-danger">Розміри 29x19</h4>
      <div className="row">
        <div className="col-md-8">
          <h3>Вимоги до файлів</h3>

          <table class="table table-striped">
            <tbody>
              <tr>
                <th scope="row" className="text-success">
                  Формат файлу
                </th>
                <td>JPG (максимальна якість)</td>
              </tr>
              <tr>
                <th scope="row" className="text-success">
                  Колірна модель
                </th>
                <td>RGB, профіль sRGB IEC61966</td>
              </tr>
              <tr>
                <th scope="row" className="text-success">
                  Розширення
                </th>
                <td>300 dpi(точок на дюйм)</td>
              </tr>
              <tr>
                <th scope="row" className="text-success">
                  Файл обкладинки A (для 3-8 розворотів)
                </th>
                <td>614 х 223 мм (7252 x 2634 пікселів)</td>
              </tr>
              <tr>
                <th scope="row" className="text-success">
                  Файл обкладинки B (для 9-25 розворотів)
                </th>
                <td>627 х 223 мм (7406 x 2634 пікселів)</td>
              </tr>
              <tr>
                <th scope="row" className="text-success">
                  Файл розвороту
                </th>
                <td>566 х 193 мм (6685 x 2280 пікселів)</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="col-md-4">
          <Fancybox29x19 />
        </div>
      </div>
    </>
  );
}

export function ShowClaim29x19Uni() {
  return (
    <>
      <h4 className="m-3 text-center text-danger">Розміри 29x19</h4>
      <div className="row">
        <div className="col-md-8">
          <h3>Вимоги до файлів</h3>

          <table class="table table-striped">
            <tbody>
              <tr>
                <th scope="row" className="text-success">
                  Формат файлу
                </th>
                <td>JPG (максимальна якість)</td>
              </tr>
              <tr>
                <th scope="row" className="text-success">
                  Колірна модель
                </th>
                <td>RGB, профіль sRGB IEC61966</td>
              </tr>
              <tr>
                <th scope="row" className="text-success">
                  Розширення
                </th>
                <td>300 dpi(точок на дюйм)</td>
              </tr>
              <tr>
                <th scope="row" className="text-success">
                Файл обкладинки A <br/>
                  (для 3-8 розворотів з прошарком)<br/>
                  (для 3-25 розворотів без прошарку)
                </th>
                <td>614 х 223 мм (7252 x 2634 пікселів)</td>
              </tr>
              <tr>
                <th scope="row" className="text-success">
                Файл обкладинки B <br/>
                  (для 9-25 розворотів з прошарком)<br/>
                  (для 26-40 розворотів без прошарку)
                </th>
                <td>627 х 223 мм (7406 x 2634 пікселів)</td>
              </tr>
              <tr>
                <th scope="row" className="text-success">
                  Файл розвороту
                </th>
                <td>566 х 193 мм (6685 x 2280 пікселів)</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="col-md-4">
          <Fancybox29x19 />
        </div>
      </div>
    </>
  );
}

export function ShowClaim29x19Planshet() {
  return (
    <>
      <h4 className="m-3 text-center text-danger">Розміри 29x19</h4>
      <div className="row">
        <div className="col-md-8">
          <h3>Вимоги до файлів</h3>

          <table class="table table-striped">
            <tbody>
              <tr>
                <th scope="row" className="text-success">
                  Формат файлу
                </th>
                <td>JPG (максимальна якість)</td>
              </tr>
              <tr>
                <th scope="row" className="text-success">
                  Колірна модель
                </th>
                <td>RGB, профіль sRGB IEC61966</td>
              </tr>
              <tr>
                <th scope="row" className="text-success">
                  Розширення
                </th>
                <td>300 dpi(точок на дюйм)</td>
              </tr>
              <tr>
                <th scope="row" className="text-success">
                  Файл обкладинки
                </th>
                <td>614 x 223 мм (7252 x 2634 пікселів)</td>
              </tr>
              <tr>
                <th scope="row" className="text-success">
                  Файл розвороту
                </th>
                <td>566 x 193 мм (6685 x 2280 пікселів)</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="col-md-4">
          <Fancybox29x19Planshet />
        </div>
      </div>
    </>
  );
}
